module.exports = __webpack_public_path__ + "img/testimonials.43f071e4.jpg";